import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { GSIcon } from 'src/components/shared/GSIcon'
import type { BulkApproveResult, PendingPayment } from 'src/interfaces/paymentsReview'
import { formatCentsAsUsd } from 'src/utils/invoiceMoney'
import { formatDriverName } from 'src/utils/paymentsOps/pendingPayments'

interface Props {
  result: BulkApproveResult
  payments: PendingPayment[]
}

const BulkApproveResultsComponent = ({ result, payments }: Props) => {
  const failureById = useMemo(() => {
    return result.failed.reduce<Record<string, string>>((failures, failure) => {
      return { ...failures, [failure.earningId]: failure.message }
    }, {})
  }, [result.failed])

  return (
    <div css={tw`flex flex-col gap-3`} data-testid="bulk-approve-results">
      <Typography variant="body1">
        {result.approved.length} approved · {result.failed.length} failed
      </Typography>
      <ul css={tw`m-0 flex max-h-[50vh] list-none flex-col gap-2 overflow-auto p-0`}>
        {payments.map((payment) => {
          const failureMessage = failureById[payment.id]

          return (
            <li key={payment.id} css={tw`flex flex-row items-start gap-2`}>
              <GSIcon
                iconName={failureMessage ? 'gs_circle_x' : 'gs_circle_check'}
                size={20}
                css={failureMessage ? tw`text-critical-500` : tw`text-success-500`}
              />
              <div css={tw`flex flex-col`}>
                <Typography variant="body2">
                  {formatDriverName(payment.partnerDriverName)} · {payment.partner} ·{' '}
                  {formatCentsAsUsd(payment.amount)}
                </Typography>
                {failureMessage ? (
                  <Typography variant="body2" css={tw`text-xs text-critical-500`}>
                    {failureMessage}
                  </Typography>
                ) : null}
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export const BulkApproveResults = memo(BulkApproveResultsComponent)
